import { Fragment, useContext, useRef, useEffect, useState } from "react";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  InputAdornment,
  IconButton,
  OutlinedInput,
  Divider,
} from "@mui/material";
import { Container } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import SideBanner from "../components/layout/sidebanner";
import LoadingButton from "@mui/lab/LoadingButton";
// import isEmail from "validator/lib/isEmail";
// import contains from "validator/lib/contains";
// import FormHelperText from "@material-ui/core/FormHelperText";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import useHttp from "../hooks/use-http";
import AuthContext from "../store/auth/auth-context";
import Cookie from "js-cookie";

let signUpSchema = yup.object().shape({
  firstName: yup
    .string()
    .required("Please enter first name")
    .max(35, "First name should have maximum of 35 characters"),
  lastName: yup
    .string()
    .required("Please enter last name")
    .max(35, "Last name should have maximum of 35 characters"),
  // location: yup.string().required("Please enter location"),
  // age: number().positive().integer(),
  email: yup
    .string()
    .email("Please enter a valid email address")
    .matches(/@[^.]*\./, "Please enter a valid email address")
    .required("Please enter email address")
    .max(256, "Email address should have maximum of 256 characters"),
  password: yup
    .string()
    .required("Please enter password")
    .min(8, "Password should have minimum of 8 characters")
    .max(60, "Password should have maximum of 50 characters"),
  passwordConfirmation: yup.string().required("Please enter confirm password").oneOf(
    [yup.ref("password"), ''],
    "Passwords must match"
  ),
  terms: yup
    .boolean()
    .oneOf([true], "Required terms of use")
    .required("Required terms of use"),
});

const SignUp = () => {
  const navigate = useNavigate();
  const authCxt = useContext(AuthContext);
  const { isLoading, isError, message, sendRequest: signUpUser } = useHttp();
  const [signupStatus, setSignupStatus] = useState(false)
  const accessToken = Cookie.get("accessToken");
  const refreshToken = Cookie.get("refreshToken");

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(signUpSchema),
  });

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show: any) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (accessToken && refreshToken) navigate("/"); 
  }, []);

  const signUpResponse = (res: any) => {
    // console.log('signup res',res)
    if (res.error === false) {
      setSignupStatus(true);
      const signUpAuthData = {
        email: res.email,
        password: res.password,
      };
      // console.log(signUpAuthData)
      // authCxt.login(signUpAuthData);
      // navigate("/");
    }
  };

  const onSubmit = (data: any) => {
    setSignupStatus(false)
    // console.log("signup data", data);
    signUpUser(
      {
        URL: "/api/user/signup",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          firstName: data.firstName, // "Kumar",
          lastName: data.lastName, //"Natarajan",
          userName: data.email, //"Kumar",
          // location: data.location, //"GI",
          email: data.email, //"kumarn2@gain-insights.com",
          password: data.password, //"Kumar@4321"
        },
      },
      signUpResponse
    );
  };

  return (
    <Fragment>
      <Container
        component="main"
        maxWidth={false}
        disableGutters
        sx={{ height: "100vh" }}
      >
        <Box
          sx={{
            margin: 0,
            height: "100vh",
          }}
        >
          <Grid container>
            <CssBaseline />

            <Grid
              item
              xs={false}
              sm={5}
              spacing={2}
              // md={0}
              sx={{
                display: { xs: "none", sm: "flex", lg: "flex" },
                backgroundImage: "url(/assets/Elements/Login-side-panel.png)",
                backgroundRepeat: "no-repeat",
                backgroundColor: (t) =>
                  t.palette.mode === "light"
                    ? t.palette.grey[50]
                    : t.palette.grey[900],
                backgroundSize: "cover",
                backgroundPosition: "center",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SideBanner></SideBanner>
            </Grid>

            <Grid
              item
              xs={12}
              sm={7}
              // md={0}
              component={Paper}
              elevation={0}
              square
            >
              <Grid
                sx={{
                  mx: 4,
                  display: "flex",
                  height: "100vh",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "Space-between",
                }}
              >
                <Grid item>
                  <Typography variant="body2"> </Typography>
                </Grid>

                {signupStatus === false ? (

                <Grid item sx={{ width: "100%" }} xs={12} sm={10} md={8}>
                  <Box
                    mt={2}
                    component="form"
                    noValidate
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <Typography component="h5" variant="h5">
                      Sign up
                    </Typography>
                    <Typography
                      variant="body2"
                      mb={2}
                      mt={1}
                      sx={{ color: isError ? "red" : "gray" }}
                    >
                      {isError
                        ? message
                        : "Begin your new analytics journey here. FREE forever up to 10 users."}

                      {/* {!errors ? "Get started now and get FREE access to 10 users.": errors.firstName?.message || errors.lastName?.message} */}
                    </Typography>
                    <Divider light={true} />

                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" mt={2} mb={1}>
                          First Name
                        </Typography>
                        <TextField
                          error={Boolean(errors.firstName)}
                          variant="outlined"
                          helperText={
                            errors.firstName ? errors.firstName.message : " "
                          }
                          // OutlinedInputProps= {errorText={"First Name should not ne empty"}}
                          required
                          fullWidth
                          placeholder="First Name"
                          size="small"
                          id="firstName outlined-error"
                          // name="firstName"
                          {...register("firstName")}
                          //   autoComplete="email"
                          autoFocus
                          // sx={{ mb: 3 }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" mt={2} mb={1}>
                          Last Name
                        </Typography>
                        <TextField
                          error={Boolean(errors.lastName)}
                          variant="outlined"
                          helperText={
                            errors.lastName ? errors.lastName.message : " "
                          }
                          required
                          fullWidth
                          placeholder="Last Name"
                          size="small"
                          id="lastName outlined-error"
                          // name="lastName"
                          {...register("lastName")}
                          //   autoComplete="email"
                          // autoFocus
                          // sx={{ mb: 2 }}
                        />
                      </Grid>
                    </Grid>

                    {/* <Typography variant="subtitle2">Location</Typography>
                    <TextField
                      error={Boolean(errors.location)}
                      variant="outlined"
                      helperText={errors.location ? errors.location.message : " "}
                      required
                      fullWidth
                      placeholder="Location"
                      size="small"
                      id="location outlined-error"
                      // name="location"
                      {...register("location")}
                      //   autoComplete="email"

                    /> */}

                    <Typography variant="subtitle2" mb={1}>
                      Email Address
                    </Typography>
                    <TextField
                      error={Boolean(errors.email)}
                      required
                      fullWidth
                      variant="outlined"
                      helperText={errors.email ? errors.email.message : " "}
                      placeholder="name@company.com"
                      size="small"
                      id="email outlined-error"
                      {...register("email")}
                      autoComplete="email"
                    />

                    <Typography variant="subtitle2" mb={1}>
                      Password
                    </Typography>
                    <TextField
                      error={Boolean(errors.password)}
                      variant="outlined"
                      helperText={
                        errors.password ? errors.password.message : " "
                      }
                      required
                      fullWidth
                      placeholder="************"
                      {...register("password")}
                      type={showPassword ? "text" : "password"}
                      id="password"
                      size="small"
                      // sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff
                                  sx={{ color: "#8D8D8D", fontSize: "1.2rem" }}
                                />
                              ) : (
                                <Visibility
                                  sx={{ color: "#8D8D8D", fontSize: "1.2rem" }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }} //////////////////////////////
                    />


<Typography variant="subtitle2" mb={1}>
                      Confirm Password
                    </Typography>
                    <TextField
                      error={Boolean(errors.passwordConfirmation)}
                      variant="outlined"
                      helperText={
                        errors.passwordConfirmation ? errors.passwordConfirmation.message : " "
                      }
                      required
                      fullWidth
                      placeholder="************"
                      {...register("passwordConfirmation")}
                      type={showPassword ? "text" : "password"}
                      id="passwordConfirmation"
                      size="small"
                      // sx={{ mb: 2 }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff
                                  sx={{ color: "#8D8D8D", fontSize: "1.2rem" }}
                                />
                              ) : (
                                <Visibility
                                  sx={{ color: "#8D8D8D", fontSize: "1.2rem" }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }} //////////////////////////////
                    />


                    <Grid container>
                      <Grid item xs>
                        <FormControlLabel
                          control={
                            <Checkbox
                              sx={{
                                // color: Boolean(errors.terms)
                                //   ? "#FF0606"
                                //   : "#8D8D8D",
                                "&.Mui-checked": {
                                  color: "#F47907",
                                },
                              }}
                              size="small"
                              // value=
                              // color="primary"
                              // name="terms"
                              {...register("terms")}
                            />
                          }
                          label={
                            <Box component="div" fontSize={".7rem"}>
                              I agree to the{" "}
                              <NavLink to="https://senseops.com/terms-of-use/">Terms of use</NavLink> and{" "}
                              <NavLink to="https://senseops.com/privacy-policy/">Privacy Policy</NavLink>
                            </Box>
                          }
                          sx={{
                            //color: Boolean(errors.terms) ? "red" : "#8D8D8D"
                            color: "red",
                          }}
                        />
                        <Typography
                          sx={{
                            color: Boolean(errors.terms)
                              ? "#FF0606"
                              : "#8D8D8D",
                            fontSize: "0.75rem",
                            pl: "15px",
                          }}
                        >
                          {Boolean(errors.terms)
                            ? "Please accept terms and conditions"
                            : " "}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        // loadingPosition={"start"}
                        loading={isLoading}
                        sx={{
                          mt: 3,
                          mb: 2,
                          width: "250px",
                          bgcolor: "#F47907",
                          fontSize: "11px",
                          "&.Mui-disabled": {
                            background: "#f6d9b9",
                          },
                          "&:hover":{
                            bgcolor: "#FF8D24",
                          }
                        }}
                      >
                        Sign up
                      </LoadingButton>

                      

                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Typography variant="body2" sx={{ color: "gray" }}>
                        {"Already have a SenseOps account? "}
                        <NavLink to="/login">Login</NavLink>
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                ) : (
                    <Grid sx={{ width: "100%", textAlign: "center" }}>
                      
                      <Box>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <LoadingButton
                            // loading={isLeading}

                            variant="text"
                            sx={{
                              mt: 3,
                              mb: 2,
                              width: "100px",

                              height: "100px",
                            }}
                          >
                            <CheckCircleOutlineIcon
                              sx={{ color: "#5ACE65", fontSize: "60px" }}
                            />
                          </LoadingButton>
                        </Box>

                        <Typography
                          component="h5"
                          variant="h5"
                          sx={{ fontSize: "30px" }}
                        >
                          {"Sign up successful!"}
                        </Typography>
                        <Typography
                          variant="body2"
                          mb={2}
                          mt={1}
                          sx={{ color: "gray", fontSize: "16px" }}
                        >
                          {
                            "We've sent a verification link to your registered email address. Please verify your account before you login."
                          }
                        </Typography>
                        <Divider light={true} />

                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <NavLink to="/login">
                            <LoadingButton
                              type="submit"
                              variant="contained"
                              loading={isLoading}
                              sx={{
                                mt: 3,
                                mb: 2,
                                width: "250px",
                                bgcolor: "#F47907",
                                fontSize: "11px",
                                "&.Mui-disabled": {
                                  background: "#f6d9b9",
                                },
                                "&:hover": {
                                  bgcolor: "#FF8D24",
                                },
                              }}
                            >
                              Proceed without verification
                            </LoadingButton>
                          </NavLink>
                        </Box>
                      </Box>
                    </Grid>
                  )}

                <Grid item mb={2}>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    If you're facing any issues on this page, Please{" "}
                    <NavLink to="#">contact us</NavLink>
                  </Typography>
                </Grid>
              </Grid>


            </Grid>
          </Grid>
        </Box>
      </Container>
    </Fragment>
  );
};

export default SignUp;
